module.exports = __webpack_public_path__ + "static/media/2.9ca97864.jpg";